'use strict';

angular.module('MoreAppsServices').factory('$mobileService', function () {

  return {
    isMobileDevice: function () {
      return ionic.Platform.isIOS() || ionic.Platform.isAndroid() || ionic.Platform.isWindowsPhone();
    }
  };
});